export class DataAfterCloseDeleteStationConfigModal {

    successDelete: boolean;

    constructor() {
    }

}
